"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fullName = fullName;
exports.addressFull = addressFull;
const utils_1 = require("core/utils");
function fullName(obj) {
    return (((obj && obj.firstName) || '') + ' ' + ((obj && obj.lastName) || '')).trim();
}
function addressFull(contactInfo) {
    let full = contactInfo.addressStreet1 || '';
    full = (0, utils_1.concatIfNotEmpty)(full, contactInfo.addressStreet2);
    full = (0, utils_1.concatIfNotEmpty)(full, (0, utils_1.concatIfNotEmpty)(contactInfo.addressCity, contactInfo.addressState), ',');
    return (0, utils_1.concatIfNotEmpty)(full, contactInfo.addressZipcode, ',');
}
